import { useDispatch, useSelector } from "react-redux";
import "../../Static Files/styles/Users/users.css";
import { useEffect, useState } from "react";
import { fetchRoles, fetchUsers } from "../../slices/userSlice";
import Modal from "../../Components/addModal.jsx";
import RoleAssignModal from "../../Components/assignRoleModal.jsx";

const Users = () => {
  const dispatch = useDispatch();
  const [addOpen, setAddOpen] = useState(false);
  const [roleModalOpen, setRoleModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const { users, roles } = useSelector((state) => state.users);

  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(fetchRoles());
  }, [dispatch]);

  const openRoleModal = (user) => {
    setSelectedUser(user);
    setRoleModalOpen(true);
  };

  return (
    <>
      <div className={addOpen ? "page-overlay" : ""}>
        <section className="users-section">
          <div className="top">
            <ul className="users-card-list">
              <li><a href="#">Bütün istifadəçilər</a></li>
              <li><a href="#">Super Adminlər</a></li>
              <li><a href="#">Moderatorlar</a></li>
            </ul>
            <ul className="operation">
              <li>
                <a href="#" onClick={() => setAddOpen(true)}>Yeni istifadəçi yarat</a>
              </li>
            </ul>
          </div>
          <table className="tab-users" border="1" style={{ width: "100%", textAlign: "left" }}>
            <thead>
              <tr>
                <th>ID</th>
                <th>Ad</th>
                <th>Soyad</th>
                <th>Elektron poçt</th>
                <th>Status</th>
                <th>Əməliyyatlar</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td>{user.id}</td>
                  <td>{user.firstName}</td>
                  <td>{user.lastName}</td>
                  <td>{user.email}</td>
                  <td>{user.status}</td>
                  <td>
                    <button onClick={() => openRoleModal(user)}>✏️ Rol əlavə et</button>
                    <button style={{ marginLeft: "10px", color: "red" }}>🗑️ Sil</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        <Modal isOpen={addOpen} onClose={() => setAddOpen(false)} />
        <RoleAssignModal isOpen={roleModalOpen} onClose={() => setRoleModalOpen(false)} selectedUser={selectedUser} />
      </div>
    </>
  );
};

export default Users;